/* =========================
   PIERPAOLOMAROTTA - custom.js
   ========================= */

/* -------------------------------------------------
   FORCE "DISPONIBILE" FILTER ON COLLECTION PAGES (Impulse-safe)
   - Checks filter.v.availability=1 by default
   - Works even if filters are injected/updated via AJAX
-------------------------------------------------- */
(function () {
  'use strict';

  if (!location.pathname.startsWith('/collections/')) return;

  if (window.__PPM_AVAIL_DEFAULT__) return;
  window.__PPM_AVAIL_DEFAULT__ = true;

  function applyAvailabilityDefault() {
    // Se già presente nell'URL, non forziamo
    const params = new URLSearchParams(location.search);
    if (params.has('filter.v.availability')) return true;

    // Trova il checkbox "Disponibile" (di solito value="1")
    const inStock = document.querySelector('input[name="filter.v.availability"][value="1"]');
    if (!inStock) return false; // sidebar non ancora pronta

    // Se non è spuntato, spuntalo e triggera change/click (tema fa AJAX)
    if (!inStock.checked) {
      inStock.checked = true;

      // alcuni temi ascoltano click, altri change: li facciamo entrambi
      inStock.dispatchEvent(new Event('change', { bubbles: true }));
      inStock.dispatchEvent(new Event('input', { bubbles: true }));
      inStock.click();

      // Aggiorna anche l'URL senza ricaricare (così resta coerente)
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('filter.v.availability', '1');
        history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    return true;
  }

  // 1) tentativo subito
  if (applyAvailabilityDefault()) return;

  // 2) se il DOM arriva dopo (AJAX), osserva fino a quando compare il checkbox
  const obs = new MutationObserver(() => {
    if (applyAvailabilityDefault()) obs.disconnect();
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });

  // 3) fallback: dopo un po' smettiamo di osservare
  setTimeout(() => obs.disconnect(), 8000);
})();


/* -------------------------------------------------
   2) PDP PRICE FIX (YOUR CODE - UNCHANGED)
-------------------------------------------------- */
(function () {
  'use strict';

  if (!location.pathname.includes('/products/')) return;

  window.__PPM_PRICE_FIX__ = true;

  function moneyEUR(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getVariantIdFromUrl() {
    return new URLSearchParams(location.search).get('variant');
  }

  function calcSavePercent(compareCents, priceCents) {
    if (compareCents == null || priceCents == null) return null;
    if (compareCents <= priceCents) return null;
    const pct = Math.round(((compareCents - priceCents) / compareCents) * 100);
    if (!Number.isFinite(pct) || pct <= 0) return null;
    return pct;
  }

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  // Fonte dati robusta: product JSON (include compare_at_price)
  let variantMapPromise = null;

  function loadProductJsonOnce() {
    if (variantMapPromise) return variantMapPromise;
    const url = location.pathname.replace(/\/$/, '') + '.js';

    variantMapPromise = fetch(url, { credentials: 'same-origin' })
      .then(r => r.json())
      .then(product => {
        const map = new Map();
        (product.variants || []).forEach(v => map.set(String(v.id), v));
        return map;
      })
      .catch(() => null);

    return variantMapPromise;
  }

  function updateMobileHeader(priceCents, compareCents) {
    const saleEl = document.querySelector('.pdp-mobile-header__price-sale');
    const origEl = document.querySelector('.pdp-mobile-header__price-original');
    const discEl = document.querySelector('.pdp-mobile-header__price-discount');

    if (saleEl) saleEl.textContent = moneyEUR(priceCents);

    const hasCompare = compareCents != null && compareCents > priceCents;

    if (origEl) {
      if (hasCompare) {
        origEl.textContent = moneyEUR(compareCents);
        origEl.style.display = '';
      } else {
        origEl.style.display = 'none';
      }
    }

    if (discEl) {
      if (hasCompare) {
        const pct = calcSavePercent(compareCents, priceCents);
        if (pct) {
          discEl.textContent = `Save ${pct}%`; // identico a ora
          discEl.style.display = '';
        } else {
          discEl.style.display = 'none';
        }
      } else {
        discEl.style.display = 'none';
      }
    }
  }

  function updateDesktopSavings(priceCents, compareCents) {
    const pct = calcSavePercent(compareCents, priceCents);
    const els = [...document.querySelectorAll('[data-save-price], .product__price-savings')].filter(isVisible);
    if (!els.length) return;

    if (pct) {
      els.forEach(el => {
        el.textContent = `Save ${pct}%`; // identico a ora
        el.style.display = '';
      });
    } else {
      els.forEach(el => { el.style.display = 'none'; });
    }
  }

  function updateAllPriceTexts(priceCents, compareCents) {
    const els = [
      ...document.querySelectorAll('[data-product-price], .product__price, .price-item, .price__current, .price')
    ];

    const visible = els.filter(isVisible);
    const targets = visible.length ? visible : els;

    targets.forEach(el => {
      const td = (getComputedStyle(el).textDecorationLine || '');
      if (td.includes('line-through')) return;
      el.textContent = moneyEUR(priceCents);
    });

    const hasCompare = compareCents != null && compareCents > priceCents;

    targets.forEach(el => {
      const td = (getComputedStyle(el).textDecorationLine || '');
      if (!td.includes('line-through')) return;

      if (hasCompare) {
        el.textContent = moneyEUR(compareCents);
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  async function updatePriceUI() {
    const id = getVariantIdFromUrl();
    if (!id) return;

    const map = await loadProductJsonOnce();
    if (!map) return;

    const v = map.get(String(id));
    if (!v) return;

    const priceCents = Number(v.price);
    const compareCents = (v.compare_at_price == null) ? null : Number(v.compare_at_price);

    updateAllPriceTexts(priceCents, compareCents);
    updateMobileHeader(priceCents, compareCents);
    updateDesktopSavings(priceCents, compareCents);
  }

  function scheduleUpdates() {
    Promise.resolve().then(updatePriceUI);
    setTimeout(updatePriceUI, 80);
    setTimeout(updatePriceUI, 250);
  }

  const _rep = history.replaceState.bind(history);
  history.replaceState = function () {
    const r = _rep.apply(this, arguments);
    scheduleUpdates();
    return r;
  };

  document.addEventListener('change', function (e) {
    const t = e.target;
    if (!t) return;
    if (t.matches('input[name="id"], select[name="id"], .variant-input, [data-variant-input]')) {
      scheduleUpdates();
    }
  }, true);

  scheduleUpdates();
})();


/* -------------------------------------------------
   3) PDP: PINCH ON INLINE IMAGE -> OPEN PHOTOSWIPE
   + open slightly zoomed (only on pinch-open)
-------------------------------------------------- */
(function () {
  // Attiva solo su touch devices
  if (!('ontouchstart' in window)) return;

  // Selettore area immagine principale
  var IMAGE_TAP_TARGET = '.product-image-main .image-wrap';

  // Quanto zoom applicare all'apertura via pinch (1.3–1.6 consigliato)
  var PINCH_OPEN_ZOOM = 1.8;

  function findPhotoswipeInstance(container) {
    return container && container.photoswipe ? container.photoswipe : null;
  }

  function zoomAfterOpen(ps) {
    // ps è theme.Photoswipe; l’istanza PhotoSwipe vera è in ps.gallery (Impulse/Archetype)
    var tries = 0;
    var maxTries = 20;

    function step() {
      tries++;

      var g = ps && ps.gallery ? ps.gallery : null;

      // PhotoSwipe v4
      if (g && typeof g.zoomTo === 'function' && typeof g.getZoomLevel === 'function') {
        try {
          var current = g.getZoomLevel();
          var target = Math.max(current || 0, PINCH_OPEN_ZOOM);

          // centro schermo (togliendo la barra 72px)
          var cx = window.innerWidth / 2;
          var cy = (window.innerHeight - 72) / 2;

          g.zoomTo(target, { x: cx, y: cy }, 160);
        } catch (e) {}
        return;
      }

      if (tries < maxTries) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  document.addEventListener('touchstart', function (e) {
    // Pinch = 2 dita
    if (!e.touches || e.touches.length !== 2) return;

    var wrap = e.target.closest(IMAGE_TAP_TARGET);
    if (!wrap) return;

    var container =
      wrap.closest('[data-product-image-main]') ||
      wrap.closest('.product-main-slide') ||
      wrap.parentElement;

    if (!container) return;

    var trigger = wrap.classList.contains('js-photoswipe__zoom') ? wrap : wrap.querySelector('.js-photoswipe__zoom');
    if (!trigger) return;

    var ps = findPhotoswipeInstance(container);

    if (ps && typeof ps.triggerClick === 'function') {
      ps.triggerClick({ currentTarget: trigger, preventDefault: function(){} });
      zoomAfterOpen(ps);
    } else {
      trigger.click();
    }
  }, { passive: true });
})();
